import { WatchStatus } from "./watchStatus";
import { WatchService, WatchType } from "./watchService";
import { AppleWatch } from "./appleWatch";
import { isAndroid, isIos } from "../platformDetection";
import { WearOsWatch } from "./wearOsWatch";
import { MockWatch } from "./mockWatch";
import { GarminWatch } from "./GarminWatch";
import { Capacitor } from "@capacitor/core";

export const watchStatusInstance =
    isAndroid() || isIos() ? new WatchStatus() : null;
export const appleWatchInstance = isIos() ? new AppleWatch() : null;
export const wearOsInstance = isAndroid() ? new WearOsWatch() : null;
export const garminInstance = Capacitor.isNativePlatform()
    ? new GarminWatch()
    : new MockWatch(WatchType.garmin);
export const mockWatchInstance = new MockWatch();
export const watchInstance =
    appleWatchInstance || wearOsInstance || mockWatchInstance;
export const watchServiceInstance = new WatchService(
    watchInstance,
    garminInstance
);
